import vm from 'vue'
import choosePrint from './index.vue'

// let choosePrintConstructor = Vue.extend(choosePrint)
// let instance
// const wmsPrint = function(options = {}) {
//     instance = new choosePrintConstructor({
//         data: options
//     })
//     document.body.appendChild(instance.$mount().$el) //this.$el拿到组件实际上的dom，把他挂载到body上
//     // setTimeout(() => {
//     //     document.body.removeChild(instance.$mount().$el) 
//     // }, 3000);  //3秒之后自动移除dom组件

// }

// export default wmsPrint

export default {
    print(){
        const choosePrintCom = vm.component('choosePrint',choosePrint);
        // 获取uniapp根节点
        // const uniappRoot = document.getElementsByTagName("uni-app")[0];
        // 初始化toast组件
		const choosePrintComp = new choosePrintCom();
        // 这里我每个组件内都有一个固定id，用来禁止同意组件生成多次
		if(document.getElementById(choosePrintComp.id)){
			document.getElementById(choosePrintComp.id).remove();
		}
        // 将toast组件添加在uniapp根节点上
		// uniappRoot.appendChild(toastComp.$mount().$el);
        document.body.appendChild(choosePrintComp.$mount().$el)
		return choosePrintComp;
    }
}